import ThreeBreathFlow from "@/components/Exercises/Breathing/ThreeBreathFlow";
import threeBreathAudio from "@/assets/audios/three-min-breathing-space.m4a";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";

export const Route = createFileRoute(
  "/(content)/adults/exercises/(shared)/three-breath/",
)({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "Three Minute Breathing Exercise - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "threeBreath.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showFlow, setShowFlow] = useState(false);

  const startExercise = () => setShowFlow(true);
  const closeFlow = () => setShowFlow(false);

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="breathing.startExercise" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="threeBreath.intro" />
      </p>
      <MediaPlayer
        src={threeBreathAudio}
        segment={{ start: 0, end: 38 }}
        isPaused={showFlow}
      />
      <ThreeBreathFlow isShow={showFlow} onClose={closeFlow} />
    </ExerciseLayout>
  );
}
